import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleInitialize, loginSelector } from "../../store/features/auth/authSlice";
import { handleApiRouterInitialize } from "../../store/routerSlice";
import PropTypes from "prop-types";
import { Loading } from "@proscore-ai/proscore-ui-library";

export default function AuthWrapper({ children }) {
  const dispatch = useDispatch();
  const { isMounted, isAuthenticated } = useSelector(loginSelector);

  useEffect(() => {
    dispatch(handleInitialize());
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated && isMounted) {
      dispatch(handleApiRouterInitialize());
    }
  }, [dispatch, isAuthenticated, isMounted]);

  if (!isMounted) return <Loading />;
  return children;
}

AuthWrapper.propTypes = {
  children: PropTypes.node
};
